// Function to handle the "Load More" button click
function handleLoadMoreClick() {
  var totalPages = parseInt(document.querySelector('[data-all-pages]').value);
  var currentPage = parseInt(document.querySelector('[data-this-page]').value);
  var datacollurl = document.querySelector('[data-coll-url]').value;
  var $this = this;

  $this.disabled = true;
  $this.querySelector('[load-more-text]').classList.add('hide');
  $this.querySelector('[loader]').classList.remove('hide');

  var nextUrl = document.querySelector('[data-next-link]').value;
  console.log(nextUrl)
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  fetch(nextUrl)
    .then(response => response.text())
    .then(responseHTML => {
      var parser = new DOMParser();
      var htmlDocument = parser.parseFromString(responseHTML, 'text/html');
      var data1 = htmlDocument.querySelector('#product-grid').innerHTML;
      var data2 = htmlDocument.querySelector('#product-grid-second').innerHTML;

      document.querySelector('[data-next-link]').value = datacollurl + "?page=" + next_coll;
      document.querySelector('[data-this-page]').value = current_page_new;

      document.querySelector('#product-grid-second').insertAdjacentHTML('beforeend', data1);
      document.querySelector('#product-grid-second').insertAdjacentHTML('beforeend', data2);
    })
    .finally(() => {
      if (current_page_new < totalPages) {
        $this.disabled = false;
        $this.querySelector('[load-more-text]').classList.remove('hide');
        $this.querySelector('[loader]').classList.add('hide');
      }
      if (current_page_new >= totalPages) {
        $this.querySelector('[load-more-text]').classList.remove('hide');
        $this.querySelector('[loader]').classList.add('hide');
        $this.style.display = 'none';
      }
    });
}

// Event delegation to handle "Load More" button click on a parent container
document.body.addEventListener('click', function (event) {
  var target = event.target;

  // Check if the clicked element or its ancestor has the class 'js-load-more'
  if (target.classList.contains('js-load-more') || target.closest('.js-load-more')) {
    // Rebind the event listener
    handleLoadMoreClick.call(target.closest('.js-load-more'));
  }
});

// Initial binding of the event listener
// document.querySelector('.js-load-more').addEventListener('click', handleLoadMoreClick);
